import * as React from 'react';
import { Box, Typography } from '@mui/material';

import { CloseButton, Dialog, DialogContent, DialogTitle, SearchInput } from 'components';
import { ESearchInputDisplayMode } from 'enums';

interface SearchResultDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
}

export const SearchResultDialog = ({ visible = false, setVisible = () => {} }: SearchResultDialogProps) => {
  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  return (
    <Dialog onClose={onClose} open={visible}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          Search
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ paddingTop: 2, paddingBottom: 2 }}>
          <SearchInput mode={ESearchInputDisplayMode.SMALL} setVisible={setVisible} />
        </Box>
      </DialogContent>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
